if (!process.env.VUE_APP_IS_WEB) {
  var TagDB = require("../database/models/Tag");

  var ResolutionCatalogTagDB = require("../database/models/ResolutionCatalogTag");
}
import strings from "@/database/strings";

import TagORM from "@/store/orm-axios/models/Tag";

import ResolutionCatalogTagORM from "@/store/orm-axios/models/ResolutionCatalogTag";
import ResolutionCatalogORM from "@/store/orm-axios/models/ResolutionCatalog";

import { _ } from "vue-underscore";

export default {
  FETCH(agencyId) {
    if (!process.env.VUE_APP_IS_WEB) {
      return new Promise((resolve, reject) => {
        new TagDB()
          .query({ where: { agency_id: agencyId, deleted: null } })
          .fetchAll({
            withRelated: [
              {
                resolution_catalog_tags: query => {
                  query.where("deleted", null);
                },
              },
            ],
          })
          .then(res => {
            TagORM.insertOrUpdate({
              data: res.serialize(),
            });
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        TagORM.api()
          .FETCH(agencyId)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  GET(id) {
    if (!process.env.VUE_APP_IS_WEB) {
      return new Promise((resolve, reject) => {
        new TagDB({ id: id, deleted: null })
          .fetch()
          .then(res => {
            TagORM.insertOrUpdate({
              data: res.serialize(),
            });
            resolve(res.serialize());
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        TagORM.api()
          .GET(id)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  POST(item, catalogId) {
    if (!process.env.VUE_APP_IS_WEB) {
      var itemPost = JSON.parse(JSON.stringify(item));
      itemPost.slug = strings.get_slug(itemPost.name);
      return new Promise((resolve, reject) => {
        new TagDB(itemPost)
          .save()
          .then(res => {
            var tag = res.serialize();
            TagORM.insertOrUpdate({
              data: tag,
            });
            var resolutionCatalogTag = {
              tag_id: tag.id,
              resolution_catalog_id: catalogId,
              agency_id: Number(localStorage.getItem("agencyId")),
            };
            new ResolutionCatalogTagDB(resolutionCatalogTag)
              .save()
              .then(res2 => {
                ResolutionCatalogTagORM.insertOrUpdate({
                  data: res2.serialize(),
                });
                resolve(tag);
              })
              .catch(err2 => {
                reject(err2);
              });

            // ???: renounce
            /**
       // console.log("res", res);
            // EX: when there is a many-to-many relationship (create + attach)
            res
              .resolutions_catalogs()
              .attach(catalogId)
              .then(relation => {
           // console.log("role attached", relation.serialize());
                ResolutionCatalogTagORM.insertOrUpdate({
                  data: {
                    resolution_catalog_id: catalogId,
                    tag_id: res.serialize().id,
                  },
                });
                TagORM.insertOrUpdate({
                  data: res.serialize(),
                });
                resolve(res.serialize());
              });
            */
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        TagORM.api()
          .POST(item)
          .then(res => {
            var tag = res.response.data;
            var resolutionCatalogTag = {
              tag_id: tag.id,
              resolution_catalog_id: catalogId,
              agency_id: Number(localStorage.getItem("agencyId")),
            };
            ResolutionCatalogTagORM.api()
              .POST(resolutionCatalogTag)
              .then(() => {
                resolve(tag);
              })
              .catch(err2 => {
                reject(err2);
              });
          })
          .catch(err => {
            reject(err);
          });

        // ???: renounce
        /**
        TagORM.api()
          .POST(item)
          .then(async res => {
            // NOTE: add in ManyToMany table
            var resolutionCatalogTags = ResolutionCatalogORM.query()
              .with("tags")
              .where("id", catalogId)
              .first().tags;
            resolutionCatalogTags.push(res.response.data["@id"]);
            var resolutionCatalog = {
              id: catalogId,
              tags: resolutionCatalogTags,
            };
            await ResolutionCatalogORM.api().PUT(resolutionCatalog);
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
        */
      });
    }
  },
  ATTACH(itemId, catalogId) {
    var resolutionCatalogTag = {
      tag_id: itemId,
      resolution_catalog_id: catalogId,
      agency_id: Number(localStorage.getItem("agencyId")),
    };
    if (!process.env.VUE_APP_IS_WEB) {
      return new Promise((resolve, reject) => {
        new ResolutionCatalogTagDB(resolutionCatalogTag)
          .save()
          .then(res => {
            ResolutionCatalogTagORM.insertOrUpdate({
              data: res.serialize(),
            });
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });

        // ???: renounce
        /**
        new TagDB({ id: itemId })
          .resolutions_catalogs()
          .attach(catalogId)
          .then(res => {
       // console.log(res);
            ResolutionCatalogTagORM.insertOrUpdate({
              data: {
                resolution_catalog_id: catalogId,
                tag_id: itemId,
              },
            });
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
        */
      });
    } else {
      return new Promise((resolve, reject) => {
        ResolutionCatalogTagORM.api()
          .POST(resolutionCatalogTag)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });

        // ???: renounce
        /**
        // NOTE: add in ManyToMany table
        var resolutionCatalogTags = ResolutionCatalogORM.query()
          .with("tags")
          .where("id", catalogId)
          .first().tags;
        var tagIri = TagORM.find(itemId)["@id"];
        resolutionCatalogTags.push(tagIri);
        var resolutionCatalog = {
          id: catalogId,
          tags: resolutionCatalogTags,
        };
        ResolutionCatalogORM.api()
          .PUT(resolutionCatalog)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
        */
      });
    }
  },
  DETACH(itemId, catalogId, pivotId) {
    if (!process.env.VUE_APP_IS_WEB) {
      return new Promise((resolve, reject) => {
        new ResolutionCatalogTagDB({ id: pivotId })
          .save(null, { isDelete: true })
          .then(res => {
            ResolutionCatalogTagORM.delete(pivotId);
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });

        // ???: ..
        /**
        new TagDB({ id: itemId })
          .resolutions_catalogs()
          .detach(catalogId)
          .then(res => {
       // console.log(res);
            ResolutionCatalogTagORM.delete([catalogId, itemId]);
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
        */
      });
    } else {
      return new Promise((resolve, reject) => {
        ResolutionCatalogTagORM.api()
          .DELETE(pivotId)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });

        // ???: renounce
        /**
        // NOTE: remove from many to many table
        var resolutionCatalogTags = ResolutionCatalogORM.query()
          .with("tags")
          .where("id", catalogId)
          .first().tags;
        var tagToBeDetached = _.findWhere(resolutionCatalogTags, { id: itemId });
        resolutionCatalogTags = _.without(resolutionCatalogTags, tagToBeDetached);
        var resolutionCatalog = {
          id: catalogId,
          tags: resolutionCatalogTags,
        };
        ResolutionCatalogORM.api()
          .PUT(resolutionCatalog)
          .then(res => {
            ResolutionCatalogTagORM.delete([catalogId, itemId]);
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
        */
      });
    }
  },
  PUT(item) {
    if (!process.env.VUE_APP_IS_WEB) {
      var itemPut = JSON.parse(JSON.stringify(item));
      itemPut.slug = strings.get_slug(itemPut.name);
      return new Promise((resolve, reject) => {
        new TagDB(itemPut)
          .save(null, { isUpdate: true })
          .then(res => {
            TagORM.insertOrUpdate({
              data: res.serialize(),
            });
            resolve(res.serialize());
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        TagORM.api()
          .PUT(item)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  DELETE(item) {
    if (!process.env.VUE_APP_IS_WEB) {
      var itemPut = JSON.parse(JSON.stringify(item));
      return new Promise((resolve, reject) => {
        new TagDB(itemPut)
          .save(null, { isDelete: true })
          .then(res => {
            TagORM.delete(item.id);
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        TagORM.api()
          .DELETE(item)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
};
